<template>
  <nuttrema-layout-cred>
    <template slot="content">
      <nuttrema-loader v-if="PersonalProfile.fetching"></nuttrema-loader>
      <nuttrema-empty-result v-else-if="PersonalProfile.error" icon="fal fa-space-shuttle">
        <template slot="text">
          <h1 v-html="$t('label.error_loading_text')"></h1>
          <h4 v-html="$t('label.error_loading_error_text')"></h4>
        </template>
      </nuttrema-empty-result>
      <router-view v-else></router-view>
    </template>
  </nuttrema-layout-cred>
</template>

<script>
import NuttremaLayoutCred from 'components/ui/layout/nuttrema-layout-cred';
import NuttremaLoader from 'components/ui/panels/nuttrema-loader';

import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

export default {
  name: 'page-my-preferences-layout',
  components: {
    NuttremaLoader,
    NuttremaLayoutCred,
    NuttremaEmptyResult,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/shared/page-my-preferences-layout.vue